import React from 'react';

const Contact = () => {
  return (
    <section id="contact" className="py-16 bg-gray-100 text-center">
      <h2 className="text-3xl md:text-4xl font-bold mb-4 text-indigo-600">Contact Me</h2>
      <p className="text-gray-700 mb-8">Let’s build something great together! Feel free to reach out via email or LinkedIn.</p>

      <div className="flex justify-center space-x-4 mb-6">
        <a
          href="mailto:priyankayadav30520@gmail.com"
          className="bg-indigo-600 text-white px-6 py-2 rounded hover:bg-indigo-700 transition"
        >
          📧 Email Me
        </a>
        <a
          href="https://www.linkedin.com/in/priyankayadav33"
          target="_blank"
          rel="noopener noreferrer"
          className="border border-indigo-600 text-indigo-600 px-6 py-2 rounded hover:bg-indigo-600 hover:text-white transition"
        >
          💼 LinkedIn
        </a>
      </div>

      <p className="text-sm text-gray-500">© {new Date().getFullYear()} Priyanka Yadav. All rights reserved.</p>
    </section>
  );
};

export default Contact;
